import React, { useState } from "react";
import consulting from "./images/consulting.jpg";
import webdesign from "./images/web-design.jpg";
import maintenance from "./images/maintenance.jpg";
import webdevelopment from "./images/dev.jpg";
import automation from "./images/automation.jpg";
import BusinessLayout from "./BusinessLayout.tsx";

const BakeryLayout: React.FC = () => {
  const [activeCategory, setActiveCategory] = useState<string>("Service1");
  const [isBusiness, setIsBusiness] = useState(false);

  const products = {
    Service1: [{ title: "UI & UX Design", description: "We create custom, modern, and user-friendly designs that captivate your audience and elevate your brand.", image: webdesign }],
    Service2: [{ title: "Web Development", description: "Our team builds secure and high-performance web applications tailored to your business needs using the latest technologies.", image: webdevelopment }],
    Service3: [{ title: "Consulting", description: "We provide strategic IT consulting to optimize your digital transformation and drive business growth.", image: consulting }],
    Service4: [{ title: "Maintenance", description: "Our maintenance services ensure your website stays secure, updated, and performing at its best around the clock.", image: maintenance }],
    Service5: [{ title: "Process Automation", description: "We leverage advanced automation tools to reduce repetitive tasks, enhance operational efficiency, and improve productivity using technologies like RPA and AI.", image: automation }]
  };

  const backgroundImages = {
    Service1: webdesign,
    Service2: webdevelopment,
    Service3: consulting,
    Service4: maintenance,
    Service5: automation

  };

  return (
    <>
      <link href="https://fonts.googleapis.com/css2?family=Cookie&display=swap" rel="stylesheet" />
      {isBusiness ? (
        <BusinessLayout />
      ) : (
        <div>
          <section id="hero" className="h-[70vh] flex items-center justify-center bg-cover bg-center relative" style={{ backgroundImage: `url(${consulting})` }}>
            <div className="absolute inset-0 bg-black opacity-50"></div>
            <div className="relative z-10 text-center text-white drop-shadow-lg px-4">
              <h1 className="text-5xl md:text-7xl font-bold font-[Cookie] mb-4">Transforming Ideas into Digital Success</h1>
              <p className="text-lg md:text-xl mb-6">We specialize in creating innovative, high-performance web solutions tailored to your business needs.</p>
              <button onClick={() => setIsBusiness(!isBusiness)} className="bg-slate-600 hover:bg-slate-700 text-white px-6 md:px-8 py-3 rounded-lg text-lg transition-all duration-300">
                Explore
              </button>
            </div>
          </section>

          <section id="products" className="py-20 px-4 md:px-6 bg-cover bg-center" style={{ backgroundImage: `url(${backgroundImages[activeCategory]})` }}>
            <div className="max-w-7xl mx-auto text-center">
              <h1 className="text-4xl md:text-6xl font-[Cookie] text-slate-600 mb-8">What we offer</h1>
              <div className="flex flex-wrap justify-center space-x-4 md:space-x-8 mb-10">
                {Object.keys(products).map((category) => (
                  <button key={category} onClick={() => setActiveCategory(category)} className={`text-lg md:text-2xl font-semibold hover:text-blue-200 transition ${activeCategory === category ? "text-blue-200" : "text-white"}`}>
                    {category.replace("Service", "")}
                  </button>
                ))}
              </div>
              <div className="grid md:grid-cols-2 lg:grid-cols-3 gap-8">
                {products[activeCategory].map((product, index) => (
                  <div key={index} className="bg-white p-6 shadow-lg rounded-lg transition-transform duration-300 transform hover:scale-105 hover:shadow-xl cursor-pointer">
                    <img src={product.image} alt={product.title} className="w-full h-40 md:h-48 object-cover rounded-md mb-4" />
                    <h3 className="text-xl md:text-3xl font-semibold text-slate-600">{product.title}</h3>
                    <p className="text-gray-600 text-sm md:text-base">{product.description}</p>
                    <button className="mt-4 text-lg md:text-2xl text-blue-300 font-[Cookie] px-4 py-2 rounded-md hover:text-blue-800 transition">See Services</button>
                  </div>
                ))}
              </div>
            </div>
          </section>
        </div>
      )}
    </>
  );
};

export default BakeryLayout;
